import React, { useEffect, useState } from 'react'
import { Select, Button, Spin, Row, Col } from 'antd'
import axios from 'axios'
import AdminHeader from '../../CommonComponents/AdminHeader'
import AdminFooter from '../../CommonComponents/AdminFooter'
import {
  getChildrenList,
  GetEducationalInfoAndDocById,
  IMG_URL,
} from '../../APIComponents/AdminApi'

const { Option } = Select

const EducationDocumentReport = () => {
  const [students, setStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [reportData, setReportData] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchStudents()
  }, [])

  const fetchStudents = async () => {
    try {
      const res = await axios.get(getChildrenList)
      setStudents(res.data)
    } catch (err) {
      console.error(err)
    }
  }

  const fetchReport = async () => {
    if (!selectedStudent) return

    setLoading(true)
    try {
      const res = await axios.get(
        `${GetEducationalInfoAndDocById}/${selectedStudent}`,
      )
      setReportData(res.data)
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }

  const isPDF = (file) => {
    return file?.toLowerCase().endsWith('.pdf')
  }

  const renderImage = (label, file) => {
    return (
      <div className="mb-3">
        <p>
          <b>{label}</b>
        </p>

        {file ? (
          isPDF(file) ? (
            <iframe
              src={`${IMG_URL}${file}`}
              title="PDF Viewer"
              className="pdf-viewer"
            />
          ) : (
            <img
              src={`${IMG_URL}${file}`}
              className="doc-img"
              alt="home-visit"
            />
          )
        ) : (
          <p>उपलब्ध नाही</p>
        )}
      </div>
    )
  }

  return (
    <>
      <AdminHeader />

      <div className="student-form-section container-fluid">
        <div className="student-form-wrapper pb-5">
          <div className="row student-form-title">
            <h3 className="section-title1 text-start mb-3">
              Educational Documents Report
            </h3>
          </div>

          <Row gutter={16} className="mb-3 shadow rounded py-3 m-0 bg-white">
            <Col md={8}>
              <Select
                className="w-100"
                placeholder="Select Student"
                onChange={(val) => setSelectedStudent(val)}
              >
                {students.map((child) => (
                  <Option key={child.id} value={child.id}>
                    {child.fname} {child.mname} {child.lname} (Reg No:{' '}
                    {child.reg_no})
                  </Option>
                ))}
              </Select>
            </Col>

            <Col md={8}>
              <Button type="primary" onClick={fetchReport}>
                Show Report
              </Button>

              <Button style={{ marginLeft: 10 }} onClick={() => window.print()}>
                Print
              </Button>
            </Col>
          </Row>

          {loading ? (
            <Spin size="large" />
          ) : reportData ? (
            <div className="a4-page">
              {/* HEADER */}
              <div className="text-center pb-3">
                <h2>
                  <b>सेंट क्रिस्पिन्स होम</b>
                </h2>
                <h5>
                  <b>शैक्षणिक कागदपत्रे अहवाल</b>
                </h5>
              </div>

              {/* DOCUMENTS */}
              <div className="section">
                {/* STUDENT NAME */}
                <div className="row p-0 m-0">
                  <div className="col-12">
                    <p>
                      <b>विद्यार्थ्याचे नाव:</b> {reportData.student.full_name}
                    </p>
                  </div>

                  <div className="col-12">
                    {renderImage(
                      '1) शाळेचा आयडी कार्ड:',
                      reportData.school_id_card,
                    )}
                    {renderImage(
                      '2) मागील वर्षाची मार्कशीट:',
                      reportData.previous_year_marksheet,
                    )}
                    {renderImage(
                      '3) शाळा सोडल्याचा दाखला (TC):',
                      reportData.transfer_certificate,
                    )}
                    {renderImage(
                      '4) बोनाफाईड सर्टिफिकेट:',
                      reportData.bonafide_certificate,
                    )}
                    {renderImage(
                      '5) विशेष प्राविण्य प्रमाणपत्र:',
                      reportData.special_achievement_certificates,
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p style={{ padding: 20 }}>No Data Found</p>
          )}
        </div>
      </div>

      <AdminFooter />

      {/* CSS */}
      <style>{`
        .a4-page {
          width: 210mm;
          min-height: 297mm;
          padding: 20px 60px;
          background: white;
          font-family: 'Noto Sans Devanagari', sans-serif;
        }

        .section {
          margin-bottom: 20px;
        }

        .section p {
          color: black;
        }

        .text-center {
          text-align: center;
        }

        .doc-img {
          width: 100%;
          height: auto;
          max-height: 500px;
          object-fit: contain;
          margin-bottom: 15px;
          border: 1px solid black;
        }

        @media print {
          body * {
            visibility: hidden;
          }

          .a4-page, .a4-page * {
            visibility: visible;
          }

          .a4-page {
            position: absolute;
            left: 0;
            top: 0;
            width: 210mm;
          }

          .doc-img {
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .section {
            page-break-inside: avoid;
          }

          .row {
            display: flex !important;
            flex-wrap: wrap !important;
          }

          .col-md-6 {
            width: 50% !important;
            float: left !important;
          }

          .col-md-4 {
            width: 33.33% !important;
            float: left !important;
          }

          .col-md-8 {
            width: 66.66% !important;
            float: left !important;
          }

          .col-md-12 {
            width: 100% !important;
            float: left !important;
          }

          .row > div {
            padding: 2px !important;
          }
        }
      `}</style>
    </>
  )
}

export default EducationDocumentReport
